import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { GoalOwnerScheduleType } from 'webapp/enums/enums';

import CommonPopupsPopupRadiobuttonListComponent from 'webapp/components/common/popups/popup-radiobutton-list';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';
import FormSelectComponent from 'webapp/components/form/select';
import ToolTipComponent from 'webapp/components/tool-tip';

interface Args {
	isDeliveryOn: boolean;
	scheduleType: GoalOwnerScheduleType;
	submitInProgress: boolean;
	optionsAsDropdown: boolean;
	toggleDelivery: () => void;
	changeScheduleType: (scheduleType: GoalOwnerScheduleType) => void;
}

export default class GoalNotificationsOwnerComponent extends Component<Args> {
	@service('popup') declare popupService: Service.Popup;

	scheduleTypes = [
		{ value: GoalOwnerScheduleType.WEEKLY, label: 'Weekly' },
		{ value: GoalOwnerScheduleType.BIWEEKLY, label: 'Bi-weekly' },
		{ value: GoalOwnerScheduleType.MONTHLY, label: 'Monthly' },
		{ value: GoalOwnerScheduleType.QUARTERLY, label: 'Quarterly' },
	];

	get isScheduleTypeDisabled() {
		return this.args.submitInProgress || !this.args.isDeliveryOn;
	}

	@action
	openOptionsInPopup(e: PointerEvent) {
		if (this.args.submitInProgress) {
			return;
		}

		if (this.popupService.isOpen(CommonPopupsPopupRadiobuttonListComponent)) {
			return;
		}

		const attachTo = e.target as HTMLElement;
		if (!attachTo) {
			return;
		}

		const popup = this.popupService.createContext(
			CommonPopupsPopupRadiobuttonListComponent,
			attachTo,
			{
				popupClass: 'popup-type-radiobutton-list',
			},
		);

		popup.open({
			title: 'Frequency',
			selected: this.args.scheduleType,
			options: this.scheduleTypes,
			onChange: (value: AnySimpleValue) => {
				this.args.changeScheduleType(value as GoalOwnerScheduleType);
			},
		});
	}
	<template>
		<div class="goal-notifications goal-notifications--owner">
			<div class="goal-notifications--switch">
				<FormCheckboxSwitchComponent
					@name="notifications"
					@selected={{@isDeliveryOn}}
					@onChange={{@toggleDelivery}}
					@isDisabled={{@submitInProgress}}
					@size="small"
				/>
				<ToolTipComponent @text="Turn all notifications on or off" @position="top" />
			</div>
			<label>
				Notify
				<em>goal owner</em>
				about updating the progress{{#if @optionsAsDropdown}}:{{/if}}
			</label>
			{{#if @optionsAsDropdown}}
				<div class="owner-schedule">
					<FormSelectComponent
						name="schedule-type"
						@options={{this.scheduleTypes}}
						@selected={{@scheduleType}}
						@isDisabled={{this.isScheduleTypeDisabled}}
						@isRequired={{true}}
						@onChange={{@changeScheduleType}}
					/>
				</div>
			{{else}}
				<a class="settings-icon" {{on "click" this.openOptionsInPopup}}>
					<CommonUiIconComponent @name="Settings" @size="sm" />
				</a>
			{{/if}}
		</div>
	</template>
}
